package com.anjuros.website.templates.template6.modules

import com.anjuros.website.templates.template6.util.ResKey


enum class Template6Review(
    var title: ResKey,
    var review: ResKey
) {

    Review1(
        ResKey.TEMPLATE6_REVIEW1_TITLE,
        ResKey.TEMPLATE6_REVIEW1
    ),
    Review2(
        ResKey.TEMPLATE6_REVIEW2_TITLE,
        ResKey.TEMPLATE6_REVIEW2
    ),
    Review3(
        ResKey.TEMPLATE6_REVIEW3_TITLE,
        ResKey.TEMPLATE6_REVIEW3
    ),
    Review4(
        ResKey.TEMPLATE6_REVIEW4_TITLE,
        ResKey.TEMPLATE6_REVIEW4
    ),
    Review5(
        ResKey.TEMPLATE6_REVIEW5_TITLE,
        ResKey.TEMPLATE6_REVIEW5
    ),
    Review6(
        ResKey.TEMPLATE6_REVIEW6_TITLE,
        ResKey.TEMPLATE6_REVIEW6
    ),
    Review7(
        ResKey.TEMPLATE6_REVIEW7_TITLE,
        ResKey.TEMPLATE6_REVIEW7
    ),
    Review8(
        ResKey.TEMPLATE6_REVIEW8_TITLE,
        ResKey.TEMPLATE6_REVIEW8
    ),
    Review9(
        ResKey.TEMPLATE6_REVIEW9_TITLE,
        ResKey.TEMPLATE6_REVIEW9
    )


}